import React from "react";

const DeliveryPolicy = () => {
  return (
    <div className="w-full max-w-4xl mx-auto p-4 md:p-8">
      <div className="bg-white shadow-md rounded-xl p-6 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold text-[#1f3b71] mb-6">
          Delivery Policy – Dhoorbin.com
        </h1>

        <p className="text-gray-700 leading-relaxed mb-6">
          At Dhoorbin.com, we believe travel is about peace, not worry. Our
          service delivery method differs from conventional online travel
          agencies (OTAs). We don’t end our duty with online booking
          confirmation; we stay by your side until you reach your destination
          and confirm the service.
        </p>

        {/* 1. Digital Delivery */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            1. Digital Delivery (Instant Booking Confirmation)
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Instant Confirmation:</strong> A booking confirmation
              message (SMS/Email) is sent to your registered email and mobile
              number immediately after payment.
            </li>
            <li>
              <strong>E-Tickets & Vouchers:</strong> You will receive an
              e-ticket or digital voucher (PDF) containing booking details,
              hotel address, bus seat number, or tour guide info via email or
              WhatsApp. This is your primary booking document.
            </li>
          </ul>
        </div>

        {/* 2. Physical Delivery / On-Spot Support */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            2. Physical Delivery or On-Spot Support (Our Specialty)
          </h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Unlike other booking sites, our “Customer Service Point” ensures
            that you receive the service correctly.
          </p>

          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Hotel Bookings:</strong> Representatives are present at
              hotel reception or service points, if necessary, to facilitate
              check-in and monitor the promised room/service quality.
            </li>
            <li>
              <strong>Bus Tickets & Travel:</strong> Support agents assist at
              bus counters. Any issues with departure or seats are resolved
              immediately.
            </li>
            <li>
              <strong>Tourism Spot / Holiday Packages:</strong> Local guides or
              representatives will greet you at the spot and explain the tour.
              The on-spot support team will assist in emergencies.
            </li>
          </ul>
        </div>

        {/* 3. Timeframe and Terms */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            3. Timeframe and Terms
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Booking Processing:</strong> Digital vouchers are
              delivered within 5–10 minutes of payment under normal conditions.
            </li>
            <li>
              <strong>Network Issues:</strong> In case of delays due to server
              or network issues, our support team will manually call to confirm
              your booking.
            </li>
          </ul>
        </div>

        {/* 4. Exceptional Circumstances */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            4. Exceptional Circumstances
          </h2>
          <p className="text-gray-700 leading-relaxed">
            If the booked service is unavailable on the spot due to natural
            disasters, political unrest, or vendor error, our on-spot team will
            make every effort to provide an equivalent or better alternative
            immediately.
          </p>
        </div>

        {/* Benefits */}
        <div>
          <h2 className="text-xl font-semibold text-[#2155ad] mb-3">
            Why is this policy good for you?
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>
              <strong>Credibility:</strong> Customers understand that
              Dhoorbin.com is not just software; we are physically present to
              ensure service delivery.
            </li>
            <li>
              <strong>Competition:</strong> Our on-spot support differentiates
              us from other OTAs that rely solely on vendors, giving you
              confidence and peace of mind.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DeliveryPolicy;
